{
  "accept-invite-form-button": "Create Account",
  "accept-invite-form-heading": "Welcome to Elements!",
  "accept-invite-form-subheading": "Let’s get started by creating your account.",

  "accept-invite-email-in-use-heading": "Please use a different email address.",
  "accept-invite-email-in-use-description": "No two accounts may have the same email address, and the one you entered is already associated with another account.\n\nIf you’re trying to connect to a new advisor, please try using a different email address."
}
